import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Users from './pages/Users';
import Trainers from './pages/Trainers';
import Events from './pages/Events';
import PromoCodes from './pages/PromoCodes';
import Prices from './pages/Prices';
import Advertisements from './pages/Advertisements';
import Notifications from './pages/Notifications';
import WalletTransactions from './pages/WalletTransactions';
import Settings from './pages/Settings';
import TrainerInteractions from './pages/TrainerInteractions';
import ProfessionalSpecializations from './pages/ProfessionalSpecializations';
import ProvidingServices from './pages/ProvidingServices';
import ServiceTypes from './pages/ServiceTypes';
import UserAdmin from './pages/UserAdmin';
import DeletedTrainers from './pages/DeletedTrainers';

const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
  },
});

function App() {
  // Safely parse authentication token
  const getAuthToken = () => {
    const token = localStorage.getItem('adminToken');
    if (!token) return false;

    // Legacy fallback: older code stored `JSON.stringify(true)` => token "true"
    if (token === 'true') return false;

    // New flow stores raw JWT string
    return token;
  };

  const isAuthenticated = getAuthToken();

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />

      <Routes>
        <Route path="/login" element={!isAuthenticated ? <Login /> : <Navigate to="/" />} />
        <Route path="/" element={isAuthenticated ? <Layout /> : <Navigate to="/login" />}>
          <Route index element={<Dashboard />} />
          <Route path="users" element={<Users />} />
          <Route path="trainers" element={<Trainers />} />
          <Route path="deleted-trainers" element={<DeletedTrainers />} />
          <Route path="events" element={<Events />} />
          <Route path="professional-specializations" element={<ProfessionalSpecializations />} />
          <Route path="providing-services" element={<ProvidingServices />} />
          <Route path="services-type" element={<ServiceTypes />} />
          <Route path="promo-codes" element={<PromoCodes />} />
          <Route path="prices" element={<Prices />} />
          <Route path="advertisements" element={<Advertisements />} />
          <Route path="notifications" element={<Notifications />} />
          <Route path="wallet-transactions" element={<WalletTransactions />} />
          <Route path="trainer-interactions" element={<TrainerInteractions />} />
          <Route path="settings" element={<Settings />} />
          <Route path="user-admin" element={<UserAdmin />} />
        </Route>
      </Routes>

    </ThemeProvider>
  );
}

export default App;

